import React from 'react';
import { AuthConsumer } from './AuthContext';

const ClientName = () => (
  <AuthConsumer>{({ userName }) => <span>{userName}</span>}</AuthConsumer>
);

export default ClientName;
